import { render, staticRenderFns } from "./courseCenter.vue?vue&type=template&id=1f13b2d6&scoped=true&"
import script from "./courseCenter.vue?vue&type=script&lang=js&"
export * from "./courseCenter.vue?vue&type=script&lang=js&"
import style0 from "./courseCenter.vue?vue&type=style&index=0&id=1f13b2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f13b2d6",
  null
  
)

export default component.exports